import React from 'react';

const reqSvgs = require.context('../../../assets/images/icons', true, /\.svg$/);

const flagMap = reqSvgs.keys().reduce((images, path) => {
  const key = path.substring(path.lastIndexOf('/') + 1, path.lastIndexOf('.'));
  images[key] = reqSvgs(path).ReactComponent;
  return images;
}, {});

const IconFlag = ({ vector, ...props }) => {
  const Flag = flagMap[vector];
  if (Flag) return <Flag {...props} />;
  return null;
};

export default IconFlag;

// console.log(
//   Object.keys(flagMap).reduce(
//     (acc, _) => ({ ...acc, [_.replaceAll('-', '_').toUpperCase()]: _ }),
//     {},
//   ),
// );

export const ICON = {
  BLUE_LIGHT_BADGE: 'blue-light-badge',
  CUSTOMERS: 'customers',
  DECLINE: 'decline',
  DRAG_AND_DROP: 'drag-and-drop',
  DRAG_ICON: 'drag-icon',
  ECOMM: 'ecomm',
  EDIT_GREY: 'edit-grey',
  EDIT: 'edit',
  EDITOR_AFABET: 'editor-afabet',
  EDITOR_BOLD: 'editor-bold',
  EDITOR_CENTER: 'editor-center',
  EDITOR_IMAGE: 'editor-image',
  EDITOR_ITALIC: 'editor-italic',
  EDITOR_JUSTIFY: 'editor-justify',
  EDITOR_LEFT: 'editor-left',
  EDITOR_LINK: 'editor-link',
  EDITOR_MONOSPACE: 'editor-monospace',
  EDITOR_NUMBERIC: 'editor-numberic',
  EDITOR_RIGHT: 'editor-right',
  EDITOR_UNDERLINE: 'editor-underline',
  GREEN_CHECK: 'green-check',
  GROUP: 'group',
  ICON_PLUS_FILLED: 'icon-plus-filled',
  ICONS_ARROW_LEFT: 'icons-arrow-left',
  ICONS_ARROW2_RIGHT: 'icons-arrow2-right',
  ICONS_ASSIGN_THREAD: 'icons-assign-thread',
  ICONS_BAG_OUTLINED: 'icons-bag-outlined',
  ICONS_BELL_OUTLINED: 'icons-bell-outlined',
  ICONS_BOOKMARK_OUTLINED: 'icons-bookmark-outlined',
  ICONS_CALENDAR_FILLED: 'icons-calendar-filled',
  ICONS_CALENDAR_OUTLINED: 'icons-calendar-outlined',
  ICONS_CAP_DOWN_WHITE: 'icons-cap-down-white',
  ICONS_CAP_DOWN: 'icons-cap-down',
  ICONS_CARD_FILLED: 'icons-card-filled',
  ICONS_CARD2_FILLED: 'icons-card2-filled',
  ICONS_CHART: 'icons-chart',
  ICONS_CHEVRON_LEFT: 'icons-chevron-left',
  ICONS_CHEVRON_RIGHT: 'icons-chevron-right',
  ICONS_CLEAR: 'icons-clear',
  ICONS_CLOCK_OUTLINED: 'icons-clock-outlined',
  ICONS_CLOSE: 'icons-close',
  ICONS_CLOSE2: 'icons-close2',
  ICONS_COLLAPSE: 'icons-collapse',
  ICONS_DUPLICATE: 'icons-duplicate',
  ICONS_EDIT_FILLED: 'icons-edit-filled',
  ICONS_EDIT_FILLED2: 'icons-edit-filled2',
  ICONS_EDIT_OUTLINED: 'icons-edit-outlined',
  ICONS_EXTERNAL_LINK: 'icons-external-link',
  ICONS_INFO_FILLED: 'icons-info-filled',
  ICONS_LINE_DOT: 'icons-line-dot',
  ICONS_LOCATION_OUTLINED: 'icons-location-outlined',
  ICONS_MAIL_FILLED: 'icons-mail-filled',
  ICONS_MAIL2_FILLED: 'icons-mail2-filled',
  ICONS_MINUS: 'icons-minus',
  ICONS_MINUS2: 'icons-minus2',
  ICONS_MORE: 'icons-more',
  ICONS_MOVE: 'icons-move',
  ICONS_MOVE2: 'icons-move2',
  ICONS_NEW_MESSAGE: 'icons-new-message',
  ICONS_PAPERPLANE_FILLED: 'icons-paperplane-filled',
  ICONS_PERSON_FILLED: 'icons-person-filled',
  ICONS_PERSON_OUTLINED: 'icons-person-outlined',
  ICONS_PHONE_OUTLINED: 'icons-phone-outlined',
  ICONS_PLUS: 'icons-plus',
  ICONS_PLUS2: 'icons-plus2',
  ICONS_PLUS3: 'icons-plus3',
  ICONS_PRINT: 'icons-print',
  ICONS_RECONSILIATION: 'icons-reconsiliation',
  ICONS_REFRESH: 'icons-refresh',
  ICONS_REFUND: 'icons-refund',
  ICONS_SAVE_SOLID: 'icons-save-solid',
  ICONS_SEARCH1: 'icons-search1',
  ICONS_SEARCH2: 'icons-search2',
  ICONS_SHARE_OUTLINED: 'icons-share-outlined',
  ICONS_STAR_OUTLINED: 'icons-star-outlined',
  ICONS_TICKET: 'icons-ticket',
  ICONS_TRANSCTION_CREDIT_CARD: 'icons-transction-credit-card',
  ICONS_TRASH_FILLED: 'icons-trash-filled',
  ICONS_TRASH_OUTLINED_WHITE: 'icons-trash-outlined-white',
  ICONS_TRASH_OUTLINED: 'icons-trash-outlined',
  ICONS_VOUCHER: 'icons-voucher',
  ICONSBAGOUTLINED: 'iconsBagOutlined',
  ICONSBOOKMARKOUTLINED: 'iconsBookmarkOutlined',
  ICONSCALENDARFILLED: 'iconsCalendarFilled',
  ICONSCHECK: 'iconsCheck',
  ICONSDEVICEOUTLINED: 'iconsDeviceOutlined',
  ICONSLOCATIONOUTLINED: 'iconsLocationOutlined',
  ICONSMAILOUTLINED: 'iconsMailOutlined',
  ICONSSMILEOUTLINED: 'iconsSmileOutlined',
  LOADING: 'loading',
  MENU_BARS: 'menu-bars',
  MINUS_CIRCLE: 'minus-circle',
  MORE_MENU: 'more-menu',
  MOVE: 'move',
  OUT_OF_STOCK: 'out-of-stock',
  PLUS_CIRCLE: 'plus_circle',
  TABLE_CELLS_ICON: 'table-cells-icon',
  CLEAR: 'clear',
};
